import React from 'react'
import './footer.css'

export const  Footer = () => {
   
    return (
        <>
           <div  className='foot'>
           <div className="row">
              <div className="column">
                  <div className="footerTitle">
                     
                    </div>
                </div>
                <div className="column">
                    <img className="img1" src="scan.png" alt="" />
                    <h4>SCAN ME</h4>
                </div>
                <div className="column">
                     <p><img className="logg" src="logo_paysage.png" alt="" />
                     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                     <div className="vl"></div><br/>
                     Rue Alimentation KOUMASSI
                        BP: 3666 Bali Douala, Cameroun<br/>
                        Tél: (+237) 650 30 42 62 (+237) 650 25 83 83<br/>
                        Email: info@green-lo.com / admin@green-lo.com
                      </p><br/><hr/><br/>
                </div><br/>
                <div className="column">
                <h4 className="cb">Copyright@2022 Green Logistics | Design by Donald Amagana 
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span className="spage">Suivez-nous sur nos pages</span>
                    <div className="ad">
                      <a href="#home"><img src='linkedin-nouveau.svg' alt='twitter'/></a>
                      <a href="#home"><img src='facebook-nouveau.svg' alt='facebook'/></a>
                      <a href="#home"><img src='instagram-nouveau.svg' alt='instagram'/></a>
                       <a href="#home"><img src='twitter-nouveau2.svg' alt='twitter'/></a>
                    </div></h4>
                </div>
               
            
            </div>
           </div>
        </>
    )
  }